class FaqTabs extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('[id^="shopify-section-"]');
    if (!this.section) return;

    this.announcer = document.getElementById('screen-reader-announcement');
    if (!this.announcer) return;

    this.onToggle = this.onToggle.bind(this);

    this.accordions = this.section.querySelectorAll(
      'details[is="accordion-disclosure"]'
    );

    this.accordions.forEach(acc =>
      acc.addEventListener('toggle', this.onToggle)
    );
  }

  disconnectedCallback() {
    this.accordions?.forEach(acc =>
      acc.removeEventListener('toggle', this.onToggle)
    );
  }

  announce(text) {
    this.announcer.textContent = '';
    setTimeout(() => {
      this.announcer.textContent = text;
    }, 50);
  }

  onToggle(event) {
    const details = event.currentTarget;

    if (details.open) {
      setTimeout(() => {
        const content = details.querySelector('.accordion__content');
        const text = content?.textContent.trim();
        if (text) this.announce(text);
      }, 350);
    } else {
      const closedMsg = details.getAttribute('data-accordion-closed');
      if (closedMsg) this.announce(closedMsg);
    }
  }
}

customElements.define('faq-tabs', FaqTabs);
